<template>
  <div>
    <Header>
      <template #actions>
        <div class="iqos-tooltip-helper-box mr-8">
          <BaseButton
            variant="primary"
            bold
            color="orange-4"
            icon="qr-code"
            @click="show_test_qr_code = !show_test_qr_code"
            size="md"
          >
            {{ $t("inside.test_button") }}
          </BaseButton>

          <IQOSTooltip
            :title="$t('inside.test_button')"
            earPosition="top-right"
            size="sm"
            :qrLink="testOrderLink"
            :backdrop="false"
            @close="show_test_qr_code = false"
            v-if="show_test_qr_code"
          >
            <div style="text-align: center;">
              {{ $t("inside.test_tooltip") }}
            </div>
          </IQOSTooltip>
        </div>
        <BaseButton
          @click="$router.push({
            name: 'subscription_history',
            query: {
              from: 'inside'
            }
          })"
          color="v1-grey-10"
          variant="secondary"
          size="md"
        >{{ $t("tables.payments_history") }}</BaseButton>
      </template>
    </Header>
    <PageContainer>
      <!-- <StoreCard :mode="isProUser ? 'pro' : 'inside'" /> -->
      <SystemCard :mode="'inside'" />

      <StickersBuyCard />

      <div
        class="qrw-heading-md mb-24 mt-40"
        :class="{
        'system-settings-disabled': !isEnabled || !isEnabled
      }"
      >
        {{ $t("mode_settings.required") }}
      </div>

      <div
        class="iqos-grid"
        :class="{'system-settings-disabled': !isSystemAvailableInBillingPlan || !isEnabled}"
      >
        <div class="iqos-column">
          <PaymentCard
            :unavailable="!isEnabled"
            :mode="'inside'"
            class="right-space"
          />
          <!-- <SystemMotdPanel :unavailable="!isEnabled" :mode="'inside'" /> -->
        </div>
        <div class="iqos-column">
          <GeolocationPanel :unavailable="!isEnabled" />
          <AutoCancelPanel
            :unavailable="!isEnabled"
            :mode="'inside'"
          />
        </div>
      </div>

      <div
        class="qrw-heading-md mb-24 mt-40 v1-grey-6-color "
        :class="{
        'system-settings-disabled': !isEnabled
      }"
      >
        {{ $t("mode_settings.optional") }}
      </div>

      <div
        class="iqos-grid"
        :class="{'system-settings-disabled': !isSystemAvailableInBillingPlan || !isEnabled}"
      >
        <div class="iqos-column right-space">
          <AutoAcceptPanel />
        </div>
        <div class="iqos-column">
          <ServingFeePanel :mode="'inside'" />
        </div>
      </div>
    </PageContainer>
  </div>
</template>

<script>
import HallsPanel from '@/components/inside/HallsPanel.vue'
import CallServicesPanel from '@/components/inside/CallServicesPanel.vue'
import GeolocationPanel from '@/components/inside/GeolocationPanel.vue'
import OrderStickersPanel from '@/components/inside/OrderStickersPanel.vue'
import PaymentCard from '@/components/PaymentCard.vue'
import SelfServicePanel from '@/components/inside/SelfServicePanel.vue'
import ServingFeeMode from '@/components/general/ServingFeeMode.vue'
import StickersBuyCard from '@/components/StickersBuyCard.vue'
import SystemProgressBar from '@/components/SystemProgressBar.vue'
import StoreCard from '@/components/subscriptions/StoreCard.vue'
import SystemCard from '@/components/superbilling/SystemCard.vue'

import SystemMotdPanel from '@/components/SystemMotdPanel.vue'

import RemoteScroller from '@/components/RemoteScroller.vue'

import AutoCancelPanel from '@/components/general/AutoCancelPanel.vue'

import DemoQRCodePanel from '@/components/DemoQRCodePanel.vue'

import ServingFeePanel from '@/components/general/ServingFeePanel.vue'

import AutoAcceptPanel from '@/components/inside/AutoAcceptPanel.vue'

export default {
  data() {
    return {
      show_test_qr_code: false
    }
  },
  methods: {},
  computed: {
    cafe() {
      return this.$store.state.cafe
    },
    isSystemAvailableInBillingPlan() {
      return this.$store.getters['checkBillingPlanForPaidService']('inside')
    },
    isEnabled() {
      return this.cafe.modes.inside
    },
    hasSections() {
      if (this.isInsideLiteEnabled) return true
      return !!this.cafe.sections && this.cafe.sections.length
    },
    isInsideLiteEnabled() {
      return !!this.cafe.inside_lite
    },
    isHotel() {
      return this.$store.getters.isHotel
    },
    readyInside() {
      const from_store = Object.assign({}, this.$store.getters.readyInside)

      delete from_store.total
      delete from_store.subtotal

      return from_store
    },
    testOrderLink() {
      const first_table = btoa(`${this.$store.state.cafe._id}/0/1`)

      //hardcode test token to hide schedule modal
      const final_link = `https://app.qrwaiter.com.ua/new/${first_table}?test_token=rfOQ1ht`

      return final_link
    },
    isProUser() {
      return this.$store.getters['subscriptions/isProUser']
    }
  },
  components: {
    StoreCard,
    HallsPanel,
    CallServicesPanel,
    GeolocationPanel,
    OrderStickersPanel,
    PaymentCard,
    RemoteScroller,
    SelfServicePanel,
    ServingFeeMode,
    StickersBuyCard,
    SystemProgressBar,
    DemoQRCodePanel,
    SystemMotdPanel,
    AutoCancelPanel,
    ServingFeePanel,
    SystemCard,
    AutoAcceptPanel
  }
}
</script>

<style scoped></style>
